<template>
    <div class="wrap">
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header" class="clearfix">
                    <span>账号管理</span>
                    <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
                </div>
                <el-form :inline="true" :model="queryParams" class="demo-form-inline">
                    <el-form-item label="姓名">
                        <el-input v-model="queryParams.nickName" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="部门">
                        <el-select v-model="queryParams.deptId" placeholder="请选择部门">
                            <el-option label="全部" value="" />
                            <el-option v-for="(item,index) in classList" :key="index" :label="item.deptName" :value="item.deptId" />
                        </el-select>
                    </el-form-item> -->
                    <el-form-item>
                        <el-button type="primary" @click="getAcountList">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-card>
        </div>
        <div class="boxCard">
            <el-card class="box-card" :body-style="{padding: '0'}">
                <div slot="header">
                    <span class="tabTitle">账号列表</span>
                    <el-button type="primary" @click="showDialog('1')">新增账号</el-button>
                </div>
                <el-table :data="tableData" show-header border style="width: 100%">
                    <el-table-column type="index" align="center" label="序号" />
                    <el-table-column prop="nickName" align="center" label="姓名" />
                    <el-table-column prop="userName" align="center" label="登录账号" />
                    <el-table-column prop="phonenumber" align="center" label="手机号码" />
                    <!-- <el-table-column prop="deptName" align="center" label="部门">
                        <template slot-scope="scope">{{scope.row.dept && scope.row.dept.deptName}}</template>
                    </el-table-column> -->
                    <el-table-column prop="test" align="center" label="管理门店" width="120">
                        <template slot-scope="scope">
                            <el-popover trigger="hover" placement="top" v-if="scope.row.storeIds">
                                <p v-for="(item, index) in (scope.row.storeNames && scope.row.storeNames.split(','))" :key="index">{{index+1}}、{{ item }}</p>
                                <div slot="reference" class="name-wrapper">
                                    <el-tag size="medium">
                                        <el-link type="primary">查看详情<i class="el-icon-view el-icon--right"></i> </el-link>
                                    </el-tag>
                                </div>
                            </el-popover>
                        </template>
                    </el-table-column>
                    <el-table-column prop="createTime" align="center" label="添加时间" />
                    <el-table-column prop="roleNames" align="center" label="角色" />
                    <!-- <template slot-scope="scope">{{scope.row.userType=='1'?'药企':'门店'}}</template>
                    </el-table-column> -->
                    <!-- <el-table-column prop="status" align="center" label="账号状态">
                        <template slot-scope="scope">{{scope.row.status=='0'?'启用':'停用'}}</template>
                    </el-table-column> -->

                    <el-table-column prop="test" align="center" label="账号状态">
                        <template slot-scope="scope">
                            <el-switch v-if="(scope.row.roleNames || '').indexOf('默认管理员') < 0" v-model="scope.row.status" active-value="0" inactive-value="1" active-color="#13ce66" inactive-color="#ff4949" @change="setAcountState(scope.row)"></el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" align="center" fixed="right" width="250">
                        <template slot-scope="scope">
                            <!-- <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                            <!-- <el-button size="mini" @click="isShow = true">岗下员工</el-button> -->
                            <!-- <el-button size="mini" type="primary" @click="isShow = true">配置角色</el-button> -->
                            <el-button size="mini" type="success" @click="showDialog('2', scope.row)" v-if="(scope.row.roleNames || '').indexOf('默认管理员') < 0">编辑</el-button>
                            <el-button size="mini" type="danger" @click="delTabItem(scope.$index, scope.row)" v-if="(scope.row.roleNames || '').indexOf('默认管理员') < 0">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination :current-page.sync="pageNum" :page-size="pageSize" @size-change="barSizeChange" @current-change="barCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" background="" layout="sizes, prev, pager, next" :total="totalCount"></el-pagination>
            </el-card>
        </div>
        <my-from-dialog :isShow="isShow" :title="dialogTitle" @cancel="closeDialog" @ok="okDialog" @closeCallBack="closeCbDialog" :scrollHeight="'530px'" :dialogWidth="'60%'" :cancelBtn="true" :okBtn="true" :okBtnText="'保 存'">
            <template slot="froms">
                <el-form :model="form" ref="form" :rules="rules" label-width="100px">
                    <el-form-item label="员工姓名" prop="nickName">
                        <el-input v-model="form.nickName" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="登录账号" prop="userName">
                        <el-input v-model="form.userName" class="baseInp" :disabled="form.userId != undefined"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号码" prop="phonenumber">
                        <el-input v-model="form.phonenumber" class="baseInp"></el-input>
                    </el-form-item>
                    <el-form-item label="登录密码" v-if="form.userId == undefined">
                        <el-input v-model="form.password" class="baseInp"></el-input>
                    </el-form-item>
                    <!-- <el-form-item label="所在部门">
                        <el-select v-model="form.deptName" placeholder="请选择所在部门" @change="getDeptId" class="baseInp">
                            <el-option v-for="(item,index) in classList" :key="index" :label="item.deptName" :value="item" />
                        </el-select>
                    </el-form-item> -->

                    <el-form-item label="权限配置" v-if="form.admin !== true">
                        <el-radio-group v-model="form.userType" size="mini">
                            <el-radio label="1">药企</el-radio>
                            <el-radio label="2">门店</el-radio>
                        </el-radio-group>
                        <!-- <el-form-item label="权限配置">
                        <el-input v-model="form.password" class="baseInp"></el-input> -->
                    </el-form-item>
                    <el-form-item label="数据权限">
                        <el-select v-model="form.dataRoot" placeholder="请选择数据权限" class="baseInp">
                            <el-option label="仅限本人数据" value="仅限本人数据"></el-option>
                            <el-option label="所在部门数据" value="所在部门数据"></el-option>
                            <el-option label="全部" value="全部"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="关联门店" v-if="form.userType !== '1' && form.admin !== true">
                        <el-checkbox-group v-model="storeListDev">
                            <el-checkbox :label="item.id" name="store" v-for="(item, index) in storeList" :key="index">{{item.storeName}}</el-checkbox>
                            <!-- <el-checkbox label="地推活动" name="type"></el-checkbox>
                            <el-checkbox label="线下主题活动" name="type"></el-checkbox>
                            <el-checkbox label="单纯品牌曝光" name="type"></el-checkbox> -->
                        </el-checkbox-group>
                    </el-form-item>
                    <el-form-item label="关联角色" v-if="form.admin !== true">
                        <el-checkbox-group v-model="roleListDev">
                            <el-checkbox :label="item.roleId" name="role" v-for="(item,index) in roleList" :key="index">{{item.roleName}}</el-checkbox>
                        </el-checkbox-group>
                    </el-form-item>
                </el-form>
            </template>
        </my-from-dialog>
    </div>
</template>

<script>
import myFromDialog from '@/components/common/from_dialog';
import { objDeepCopy } from '@/utils/index';
import validate from '@/utils/validate.1.0';
let self = null;
export default {
    components: {
        myFromDialog
    },
    computed: {},
    watch: {},
    data() {
        return {
            isShow: false,
            visible: false,
            dialogType: '',
            dialogTitle: '',
            pageNum: 1,
            pageSize: 10,
            totalCount: 0,
            tableData: [],
            classList: [],
            storeList: [],
            roleList: [],
            queryParams: {
                value: '',
            },
            storeListDev: [],
            roleListDev: [],
            loginData: {},
            form: {
                value: '',
                storeList: [],
                roleList: [],
            },
            rules: this.getRules()
        }
    },
    created() {
        this.loginData = JSON.parse(localStorage.getItem('loginData')) || {};
        // this.getClassList();
        this.getStoreList();
        this.getRoleList();
        this.getAcountList();
        self = this;
    },
    methods: {
        getStoreEvent(val) {
            console.log(val);
        },
        getDeptId(item) {
            this.form.deptId = item.deptId;
            this.form.deptName = item.deptName;
        },
        initForm(item) {
            this.form = {};
            this.storeListDev = [];
            this.roleListDev = [];
            this.$set(this.form, 'userType', '1');
            if (item) {
                this.form = objDeepCopy(item);
                // this.storeListDev = item.storeList && item.storeList.split(",") || [];
                // this.roleListDev = item.roleList && item.roleList.split(",") || [];
                this.storeListDev = item.storeIds || [];
                this.roleListDev = item.roleIds || [];
                // this.form.deptName = this.$set((item.dept && item.dept.deptName) || '');
                this.$set(this.form, 'deptName', ((item.dept && item.dept.deptName) || ''))
                this.$set(this.form, 'password', '')
                // this.form.userType = item.userType+'';
                this.$set(this.form, 'userType', item.userType || '1');
            }
        },
        // 显示弹窗1
        showDialog(dialogType, item) {
            this.dialogType = dialogType;
            this.dialogTitle = dialogType == '1' ? '新增账号' : '编辑账号';
            this.isShow = true;
            this.initForm(item);
            // const { province, city, area, areaCode } = this.$refs.areaSelectPicker;
            // console.log(this.$refs.areaSelectPicker);
        },
        closeDialog(data) {
            this.isShow = false;
            console.log(data);
        },
        okDialog(data) {
            // console.log(data);
            // this.isShow = false;

            if (this.dialogType == '1') {
                if (!this.form.password) {
                    this.$message.error('新增账号请设置初始密码');
                    return;
                } else {
                    this.addAcount();
                }
            } else if (this.dialogType == '2') {
                this.editAcount();
            }
        },
        closeCbDialog(data) {
            console.log(data);
            this.isShow = false;
        },

        // 当前显示条数
        barSizeChange(val) {
            this.pageSize = val;
            this.getAcountList();
            console.log(`每页 ${val} 条`);
        },
        // 当前页
        barCurrentChange(val) {
            this.pageNum = val;
            this.getAcountList();
            console.log(`当前页: ${val}`);
        },
        getCheckedNodes() {
            console.log(this.$refs.tree.getCheckedNodes());
        },
        // 表格点击删除按钮
        delTabItem(index, item) {
            let _this = this;
            this.$confirm('是否确定删除账号?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                _this.delAcount(item.userId);
            }).catch(() => {
            });
        },
        // 获取部门列表
        getClassList() {
            let _this = this;
            this.$https.get('system/enterpriseManager/dept/list', { enterpriseId: this.loginData.enterpriseId }).then(res => {
                console.log('部门列表', res.data);
                _this.classList = res.data || [];
                // _this.$message.success('新增成功');
                // _this.getStoreList();
            }).catch(res => {

            })
        },
        // 获取关联门店列表
        getStoreList() {
            let _this = this;
            this.$https.get('system/store/findAll', { enterpriseId: this.loginData.enterpriseId }).then(res => {
                console.log('关联门店列表', res.data);
                _this.storeList = res.data || [];
                // _this.$message.success('新增成功');
                // _this.getStoreList();
            }).catch(res => {

            })

        },
        // 获取角色列表
        getRoleList() {
            let _this = this;
            this.$https.get('system/enterpriseManager/role/findAll', { enterpriseId: this.loginData.enterpriseId }).then(res => {
                console.log('获取角色列表', res.data);
                _this.roleList = res.data || [];
                // _this.$message.success('新增成功');
                // _this.getStoreList();
            }).catch(res => {

            })

        },
        // 获取账号管理列表
        getAcountList() {
            let _this = this;
            let queryParams = this.queryParams;
            let params = {
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                nickName: queryParams.nickName,
                // enterpriseId: this.loginData.enterpriseId,
                needComPms: true
                // deptId: queryParams.deptId
            };
            this.$https.post('system/enterpriseManager/user/list', params).then(res => {
                console.log(res);
                _this.tableData = res.rows || [];
                _this.totalCount = res.total;
                // _this.$message.success('新增成功');
                // _this.getStoreList();
            }).catch(res => {

            })
        },
        // 获取设置账号参数
        getParams() {
            let flag = false;
            this.$refs.form.validate(valid => {
                flag = valid;
            });
            this.form.storeIds = this.storeListDev;
            this.form.roleIds = this.roleListDev;
            // this.form.roleList = this.roleListDev&&this.roleListDev.join(',') ||'';
            this.form.loginEnterpriseId = this.loginData.enterpriseId; // 不能用公共参数，单独处理
            if (!flag) {
                this.$message.error('提交信息不完整，请检查');
                return false;
            } else {
                return this.form;
            }
        },
        // 新增账号
        addAcount() {
            let _this = this;
            let params = this.getParams();
            if (!params) return;
            this.$https.post('system/enterpriseManager/user', params).then(res => {
                console.log(res);
                // _this.tableData = res.rows || [];
                _this.$message.success('新增成功');
                _this.isShow = false;
                _this.getAcountList();
            }).catch(res => {

            })
        },
        // 编辑修改账号
        editAcount() {
            let _this = this;
            let params = this.getParams();
            if (!params) return;
            this.$https.put('system/enterpriseManager/user', params).then(res => {
                console.log(res);
                // _this.tableData = res.rows || [];
                _this.$message.success('修改成功');
                _this.getAcountList();
                _this.isShow = false;
            }).catch(res => {

            })
        },
        // 删除账号账号
        delAcount(id) {
            let _this = this;
            this.$https.delete('system/enterpriseManager/user/' + id, {}).then(res => {
                console.log(res);
                _this.getAcountList();
                _this.$message.success('删除成功');
            }).catch(res => {

            })
        },
        // 修改账号状态
        setAcountState(item) {
            let _this = this;
            let params = { userId: item.userId, status: item.status };
            this.$https.put('system/enterpriseManager/user/changeStatus', params).then(res => {
                console.log(res);
                // _this.tableData = res.rows || [];
                _this.$message.success('状态修改成功');
                // _this.getStoreList();
                // _this.isShow = false;
                _this.getAcountList();
            }).catch(res => {

            })
        },

        // 获取角色设置校验规则
        getRules() {
            return {
                nickName: { required: true, message: '请输入员工姓名', trigger: 'blur' },
                userName: { required: true, message: '请输入登录账号', trigger: 'blur' },
                phonenumber: [
                    { required: true, message: '请输入手机号码', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!validate.isvalidPhone(value)) {
                                console.log(self);
                                return callback(new Error('手机格式不正确！'));
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                password: [
                    { required: true, message: '请输入登录密码', trigger: 'blur' },
                    { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
                ]
            }
        }

    },
}
</script>

<style lang="less" scoped>
// .wrap {
//     background: red;
//     span {
//         color: blue;
//     }
// }

.wrap {
    // background: #fff;
}
.boxCard {
    margin-bottom: 20px;
}
.queryBox {
    // background: #fff;
    padding: 20px;
}
.baseInp {
    width: 300px;
}
.dlRole {
    margin-bottom: 10px;
    span {
        color: red;
    }
}
.tabTitlePd {
    padding: 10px;
    font-weight: bold;
}
.tabTitle {
    color: #333;
    font-size: 15px;
    margin-right: 30px;
}
</style>
